import React from "react";
import { useNavigate } from "react-router-dom";
import { TwoFactorEnrollment } from "../components/TwoFactorEnrollment";

export function TwoFactorSetupPage() {
    const navigate = useNavigate();

    return (
        <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src="https://assets.website-files.com/60588448b9ff270b7fecc5ce/605ca4fbd6553ae5be979457_Group(1).svg"
                    alt="Hotelchamp"
                />
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <h2 className="text-center text-2xl mb-8 font-bold text-gray-700">Set up two-factor authentication</h2>

                    <TwoFactorEnrollment completeLabel="Continue to Hotelchamp" onCompleted={() => navigate("/")} />
                </div>
            </div>
        </div>
    );
}
